import clsx from 'clsx';
import React from 'react';

import type { ButtonGroupProps } from './ButtonGroup.types';

export const ButtonGroup = React.forwardRef<HTMLElement, ButtonGroupProps>(
  ({ as: Component = 'div', children, className, ...restProps }, ref) => {
    if (!children) {
      return null;
    }
    return (
      <Component
        ref={ref}
        className={clsx('hg-button-group', className)}
        {...restProps}
      >
        {children}
      </Component>
    );
  }
);
